/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import CModalWindow from '../common/modal/modalWindow.component.container';
import DeleteDocumentModalContainer from './delete.document.container';

class DeleteDocumentModal extends React.Component {
  click(e) {
    e && e.click(); //simulated click to hide the dropdown menu
  }

  render() {
    return (
      <div id="delete-document-modal">
        <DeleteDocumentModalContainer {...this.props} />
      </div>
    );
  }
}

export default DeleteDocumentModal;
